module.exports = __webpack_public_path__ + "static/img/popup_close@3x.2642604.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/popup_close@3x.png
// module id = DYzT
// module chunks = 1